import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgArrowEnter = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 10 18" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.5.556V10.5a3 3 0 0 1-3 3H1.207h0m2.293-4-3 4m0 0 3 4"
      stroke="#CFD2D7"
      fill="none"
      strokeLinecap="square"
    />
  </svg>
);
const Memo = memo(SvgArrowEnter);
export default Memo;
